export const intervalTypeMap = [
    { name: "One-time" }, // no days on purpose
    { name: "Weekly", days: 7 },
    { name: "Bi-Weekly", days: 14 },
    { name: "Semi-Monthly", days: 14 },
    { name: "Monthly", days: 30 },
    { name: "Quarterly", days: 90 },
    { name: "Annually", days: 365 },
];

export const normalizeClientServiceInterval = (value) =>
    value === "Montly" ? "Monthly" : value;

export const getClientServiceIntervalConfig = (value) => {
    const normalizedValue = normalizeClientServiceInterval(value);
    return intervalTypeMap.find((interval) => interval.name === normalizedValue);
};
